/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { USER_SUBSCRIPTION_PLAN_PAYMENT_INVOICE } from 'pages/Vendor/VendorGraphQL';
import Loader from 'components/common/Loader';
import Base64ToPdf from 'pages/Invoices/components/PDFViewer';

function VendorInvoiceView({ id }) {
  const { data, loading, error, refetch } = useQuery(
    USER_SUBSCRIPTION_PLAN_PAYMENT_INVOICE,
    {
      variables: { id },
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    refetch({ id });
  }, [id]);

  if (error) {
    return 'Error while getting your pdf. Please refresh the page or try again later';
  }

  if (!loading || data?.userSubscriptionPaymentInvoice) {
    return <Base64ToPdf url={data?.userSubscriptionPaymentInvoice} />;
  }
  return <Loader />;
}

export default VendorInvoiceView;
